import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'lib-loader',
    imports: [MatProgressSpinnerModule, CommonModule],
    templateUrl: './loader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  @Input('hideSpinner') hideSpinner: boolean;
  @Input('leftPosition') leftPosition: string;

  constructor() { }

  ngOnInit() {
  }
}
